import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentContainer = styled.div({
  maxWidth: '100vw',
  maxHeight: 'calc(100vh - 100px)',
  minHeight: '200px',
  padding: 0,
});
